import React, { useState } from 'react';

const RatingStar = ({ totalStars = 5 }) => {
    const [rating, setRating] = useState(0);

    const handleClick = (index) => {
        setRating(index + 1);
    };

    return (
        <div className='rating-stars'>
            {[...Array(totalStars)].map((star, index) => (
                <i
                    key={index}
                    className={`fa-star ${index < rating ? 'fas' : 'far'}`}
                    onClick={() => handleClick(index)}
                    style={{ cursor: 'pointer', color: index < rating ? '#f8b409' : '#f8b409' }}
                ></i>
            ))}
        </div>
    );
};

export default RatingStar;
